<app-header [isAuthorized]="isAuthorized" (toggleSideBarForMe)="sideBarToggler($event)"></app-header>

<mat-drawer-container>
  <mat-drawer *ngIf="isAuthorized" mode="side" [opened]="sideBarOpen">
    <app-sidebar></app-sidebar>
  </mat-drawer>

  <mat-drawer-content>

    <div style="position: sticky; top: 0">
      <mat-toolbar *ngIf="!isAuthorized" class="primary"
        [ngClass]="isAuthorized ? 'toolbar-logged' : 'toolbar-not-logged'">
        <mat-toolbar-row *ngIf="{ pageTitle: pageTitle$ | async } as model">
          <a [href]="relihUrl" target="_blank"><img class="logo-image" src="/assets/logo/logo-en-transparent.png" /></a>
          <a [href]="habitatUrl" target="_blank"><img class="logo-image" src="/assets/logo/logo-en-transparent1.png" />
          </a>

          <span *ngIf="isAuthorized" class="toolbar-title">{{ model.pageTitle }}
          </span>
          <span class="example-spacer"></span>
          <div *ngIf="!isAuthorized" class="log-in-panel">

            <button mat-button (click)="showLogin()">
              <mat-icon>login</mat-icon>
              <span class="log-in-text hide-on-small-screen">
                {{
                "log-in" | translate
                }}
              </span>
            </button>

            <button mat-button (click)="showInstruction()">
              <mat-icon>help_outline</mat-icon>
              <span class="hide-on-small-screen">{{
                "instruction" | translate
                }}</span>
            </button>

            <button mat-button (click)="showContact()">
              <mat-icon>mail</mat-icon>
              <span class="hide-on-small-screen">{{
                "contact" | translate
                }}</span>
            </button>

            <div class="language-list">
              <button (click)="switchLang(item)" mat-button *ngFor="let item of getLanguages()">
                <span [ngClass]="getFlagClass(item)"></span>
                <span [ngClass]="item === language ? 'bold underlined' : ''">{{
                  item | uppercase
                  }}</span>
              </button>
            </div>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>

    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>

<app-footer></app-footer>
